import(/* webpackMode: "eager" */ "/Users/oscararmstrong/node/chipgpt/src/app/page.tsx");
